$(document).ready(function(){

    $(".tabbed-content div[class*='inner-container']").each(function(){
        var panels = $(this).children(".tabbed-panel");
        panels.hide();
        panels.first().show();
        var items = '';
        var labelArray = panels.map(function() {
            return [
                [$(this).data("anchor"),$(this).data("label")]
            ];
          }).get();
        $.each(labelArray, function(index,value) {
          items += "<li class='items'><a href='#"+value[0]+"'>"+value[1]+"</a></li>";
        });
        var menu = $("<nav class='tabbed-nav'><ul class=\"tabbed-menu\">"+items+"</ul></nav>");
        $(this).prepend(menu);
        console.log(menu);
        var tabs = menu.find("li.items a");
        tabs.first().addClass("active");
        tabs.click(function(e) {
            e.preventDefault();
            var card = $(this).attr("href");

            console.log('click: ' + card);
            tabs.removeClass();
            $(this).addClass("active");
            panels.hide();
            $(card).fadeIn("slow");
            $('ul.hidden-links').addClass('hidden');
        });

    });
});
